import { render, staticRenderFns } from "./BeneficiaryRelationshipYN.vue?vue&type=template&id=108978bc"
import script from "./BeneficiaryRelationshipYN.vue?vue&type=script&lang=js"
export * from "./BeneficiaryRelationshipYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports